// Blocco centralizzato per il trial scaduto — lato client. Non sostituisce le regole
// Firestore (quelle sono il vero vincolo, non aggirabile), ma evita che l'utente provi
// un'azione che il server rifiuterebbe comunque, mostrando subito un messaggio chiaro.
//
// Uso tipico, dentro una funzione di salvataggio/creazione:
//   const { isReadOnly, puoModificareTaskSottoattivita } = useAuth();
//   if (bloccaSeReadOnly(isReadOnly, addToast)) return;
//
// Rev2 (ott 2026): niente più eccezione per Attività/Sottoattività: stesso blocco di tutto il resto.
// (puoModificareTaskSottoattivita resta per compatibilità e vale come !isReadOnly)
//   if (isReadOnly && !puoModificareTaskSottoattivita) { ... blocca ... }

export function bloccaSeReadOnly(isReadOnly, addToast) {
  if (!isReadOnly) return false;
  addToast("Trial scaduto — attiva un piano per riabilitare questa funzionalità. Nexiora.it/piani", "error");
  return true;
}

export const MESSAGGIO_TRIAL_SCADUTO =
  "Trial scaduto — attiva un piano per riabilitare tutte le funzionalità che hai utilizzato o che desideri utilizzare.";
